import "./global/product.js";

import "./sections/main-product-eleven.js";
import "./sections/image-with-text-slider-eleven.js";
import "./sections/recommended-products-eleven.js";